import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

const DashboardLayout = ({ isMobileOpen, setIsMobileOpen }) => {
  return (
    <div className="flex">

      {/* SIDEBAR */}
      <Sidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />

      {/* RIGHT AREA */}
      <div className="flex-1 md:ml-64">

        {/* NAVBAR */}
        <Navbar setIsMobileOpen={setIsMobileOpen} />

        {/* PAGE CONTENT */}
        <div className="">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default DashboardLayout;